"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 任务信息模块
var _default = exports.default = {
  getList: function getList(data, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/taskInfo/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getDetail: function getDetail(id) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/taskInfo/query/' + id,
      method: 'post'
    });
  },
  saveTaskInfo: function saveTaskInfo(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/taskInfo/save',
      method: 'post',
      data: data
    });
  },
  exportTaskInfo: function exportTaskInfo(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/taskInfo/export',
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  }
};